module.exports = __webpack_public_path__ + "img/q1.d63b48e2.gif";